module.exports = __webpack_public_path__ + "img/credit1.c87880ab.png";